import React, { useMemo } from 'react';
import { Button, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import { ButtonSplitGroup } from '@components/Buttons';
import { BootstrapGenericTable } from '@components/Table/Table';

const renderActionCell = ({ row, dedicatedChannelsProps }) => {
  const { did, canAdd, canRemove } = row.original;
  const { add, remove } = dedicatedChannelsProps;

  return (
    <ButtonSplitGroup>
      <Button
        variant="didxl"
        size="sm"
        onClick={() => {
          remove.query(did);
        }}
        disabled={!canAdd}
      >
        +
      </Button>
      <Button
        variant="didxl"
        size="sm"
        onClick={() => add.query(did)}
        disabled={!canRemove}
      >
        -
      </Button>
    </ButtonSplitGroup>
  );
};

const renderChannelsAmountCell = ({ row, value }) => {
  const { cancellation_cart_channels: cartChannels } = row.original;
  return (
    <>
      {value}{' '}
      {cartChannels ? (
        <span className="textRed"> (-{cartChannels})</span>
      ) : null}
    </>
  );
};

const renderActionHeader = ({ dedicatedChannelsProps }) => (
  <>
    <p className="m-0">Action</p>
    <Button
      onClick={() => dedicatedChannelsProps.clear.query()}
      variant="didxl"
      size="sm"
    >
      Clear
    </Button>
  </>
);

export const CancelChannelsTable = ({
  useData,
  searchParams,
  dedicatedChannelsProps,
}) => {
  const navigate = useNavigate();
  const exportContent = () => (
    <Button
      variant="didxl"
      size="sm"
      onClick={() => {
        navigate('/cart/cancellation');
      }}
    >
      Cancel and checkout
    </Button>
  );

  const country = searchParams.get('country');
  const plan = country ? searchParams.get('plan') : '';
  const did = searchParams.get('did');
  const filterData = {
    country,
    plan,
    did,
  };

  const columns = useMemo(
    () => [
      {
        id: 'did',
        Header: 'Number',
        accessor: 'did',
        className: 'col-md-1',
      },
      {
        id: 'country',
        Header: 'Country',
        accessor: 'country',
        className: 'col-md-1',
      },
      {
        id: 'plan',
        Header: 'Plan',
        accessor: 'plan',
        className: 'col-md-1',
      },
      {
        Header: 'Channels purchased',
        accessor: 'n_bought_channels',
        className: 'col-md-1',
        Cell: renderChannelsAmountCell,
      },
      {
        Header: () => renderActionHeader({ dedicatedChannelsProps }),
        Cell: ({ row }) =>
          renderActionCell({
            row,
            dedicatedChannelsProps,
          }),
        accessor: 'action',
        className: 'col-md-1 text-center',
      },
    ],
    []
  );
  return (
    <Card>
      <Card.Header className="bg-didxl text-white">Cancel Channels</Card.Header>
      <Card.Body>
        <BootstrapGenericTable
          columns={columns}
          useData={useData}
          filterData={filterData}
          tableProps={() => ({
            responsive: true,
            bordered: true,
            className: 'normalFontSize',
          })}
          paginated
          exportContent={exportContent}
        />
      </Card.Body>
    </Card>
  );
};
